import "./styles/sass/main.scss";

import Router from "./js/util/Router";
import common from "./js/routes/common";
import contact from "./js/routes/contact";
import jobs from "./js/routes/jobs";
import events from "./js/routes/events";
import archive from "./js/routes/archive";
import toplevelPagePricingAdminPage from "./js/routes/admin-pricing";
import admin from "./js/routes/admin";

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  /** All pages */
  common,
  /** Contact page */
  contact,
  /** Job page */
  jobs,
  /** Events page */
  events,
  /** Archive page */
  archive,
  /** Admin Pricing page */
  toplevelPagePricingAdminPage,
  /** Admin page */
  admin,
});

/** Load Events */
jQuery(document).ready(() => routes.loadEvents());
